import ApiInstance from './instance'
import {
  EUserPermissions,
  IUserChainRole,
  IUserCustomPermission,
  IUserRolePermission,
  URL_MAPPING
} from '@zunta/configurations'

const { permissions: permissionsUrls } = URL_MAPPING

export default class PermissionsApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  createRole (roleData: Partial<IUserChainRole>): Promise<IUserChainRole> {
    return this.instance.doPost(`${permissionsUrls.prefix}${permissionsUrls.addUserRole.path}`, roleData)
  }

  getUserRoles (params: any): Promise<IUserChainRole[]> {
    return this.instance.doGet(`${permissionsUrls.prefix}${permissionsUrls.getUserRoles.path}`, params)
  }

  updateUserRole (roleId: number | string, name: string): Promise<'OK'> {
    return this.instance.doPut(`${permissionsUrls.prefix}${permissionsUrls.updateUserRole.path}/${roleId}`, { name })
  }

  deleteUserRole (roleId: number | string): Promise<'OK'> {
    return this.instance.doDelete(`${permissionsUrls.prefix}${permissionsUrls.deleteUserRole.path}/${roleId}`)
  }

  addRolePermission (roleId: string | number, permission: EUserPermissions): Promise<IUserRolePermission> {
    return this.instance.doPost(`${permissionsUrls.prefix}${permissionsUrls.addUserRolePermission.path}/${roleId}/${permission}`)
  }

  deleteRolePermission (roleId: string | number, permission: EUserPermissions): Promise<'OK'> {
    return this.instance.doDelete(`${permissionsUrls.prefix}${permissionsUrls.deleteUserRolePermission.path}/${roleId}/${permission}`)
  }
  getPermissions (query = {}) {
    return this.instance.doGet(`${permissionsUrls.prefix}${permissionsUrls.getPermissions.path}`, query)
  }

  getUserCustomPermissions (userId: number | string): Promise<IUserCustomPermission[]> {
    return this.instance.doGet(`${permissionsUrls.prefix}${permissionsUrls.getUserCustomPermissions.path}/${userId}`)
  }

  checkAbilityToDeleteRole (roleId: number | string): Promise<boolean> {
    return this.instance.doGet(`${permissionsUrls.prefix}${permissionsUrls.checkAbilityToDeleteRole.path}/${roleId}`)
  }
}
